module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents-b/vantaggio_portali.357b9a6fce8d8ccf11876dedab01597f.jpg";